<template>
    <div class="absolute w-full h-full" v-if="ifLoading">
        <div class="absolute flex justify-center items-center z-[60] w-full h-full ">
            <div class="w-20 h-20">
                <LoadingIcon
                    icon="three-dots"
                    class="loading-icon"
                />
            </div>
        </div>
        <div class="absolute bg-white opacity-70 w-full h-full z-50 rounded-md flex justify-center items-center">
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    ifLoading: {
    type: Boolean,
    default: false,
  },
});
</script>
